import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { NycLien } from '../types';
import { TableHeader } from './TableHeader';

interface PropTypes {
  nycLiens: NycLien[];
}

const TableRow = ({ nycLien }: { nycLien: NycLien }) => (
  <Table.Row>
    <Table.Cell collapsing>{nycLien.borough}</Table.Cell>
    <Table.Cell collapsing>{nycLien.block}</Table.Cell>
    <Table.Cell collapsing>{nycLien.lot}</Table.Cell>
    <Table.Cell collapsing>{nycLien.taxClass}</Table.Cell>
    <Table.Cell collapsing>{nycLien.buildingClass}</Table.Cell>
    <Table.Cell collapsing>{nycLien.houseNumber}</Table.Cell>
    <Table.Cell collapsing>{nycLien.streetName}</Table.Cell>
    <Table.Cell collapsing>{nycLien.zipCode}</Table.Cell>
    <Table.Cell collapsing>{nycLien.waterDebtOnly}</Table.Cell>
    <Table.Cell collapsing>{nycLien.year}</Table.Cell>
    <Table.Cell collapsing>{nycLien.regularSubsequent}</Table.Cell>
    <Table.Cell collapsing>{nycLien.trustDestination}</Table.Cell>
  </Table.Row>
);

const NycLienDataTab = (props: PropTypes) => {
  const [sortedNycLiens, setSortedNycLiens] = useState<NycLien[]>([]);

  useEffect(() => {
    if (props.nycLiens) {
      setSortedNycLiens(props.nycLiens);
    }
  }, [props.nycLiens]);

  return (
    <React.Fragment>
      {sortedNycLiens.length === 0 ? (
        <div>No Records Available</div>
      ) : (
        <Table striped columns={12} sortable>
          <TableHeader
            columnNames={[
              'Borough',
              'Block',
              'Lot',
              'Tax Class',
              'Building Class',
              'House Number',
              'Street',
              'Zip',
              'Water Debt Only',
              'Year',
              'Reg/Subsequent',
              'Trust Destination',
            ]}
            sortedData={sortedNycLiens}
            setSortedData={setSortedNycLiens}
          />
          <Table.Body>
            {sortedNycLiens.map(lien => (
              <TableRow nycLien={lien} />
            ))}
          </Table.Body>
        </Table>
      )}
    </React.Fragment>
  );
};

export default NycLienDataTab;
